import axios from "axios";

// const api = "http://localhost:3005/";
const api = "https://fresh.kito.pet/";

const instance = axios.create({
  baseURL: api,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (err?.response?.status === 401) {
      console.log(err?.response);
    }
  }
);

export { instance };
